import type { FC } from 'react';
import { Card, Col, Flex, Row, Typography } from 'antd';
import type { SiteSegmentCardViewModel } from '../../ServiceQualityPage.types';

const { Text, Title } = Typography;

export interface SiteSegmentCardProps {
  segment: SiteSegmentCardViewModel;
}

export const SiteSegmentCard: FC<SiteSegmentCardProps> = ({ segment }) => {
  return (
    <Card className="om-section-card" styles={{ body: { padding: 20 } }}>
      <Flex vertical gap={16}>
        <div>
          <Title level={5} style={{ margin: 0 }}>
            {segment.title}
          </Title>
          <Text type="secondary">{segment.siteCountLabel}</Text>
        </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={8}>
            <Text type="secondary" className="ds-card-label">
              {segment.sessionSuccessLabel}
            </Text>
            <div className="sq-segment-card__metric">
              {segment.sessionSuccessValue}{' '}
              <span className="sq-segment-card__trend">
                {segment.sessionSuccessTrend}
              </span>
            </div>
          </Col>
          <Col xs={24} sm={8}>
            <Text type="secondary" className="ds-card-label">
              {segment.ratingLabel}
            </Text>
            <div className="sq-segment-card__metric">{segment.ratingValue}</div>
          </Col>
          <Col xs={24} sm={8}>
            <Text type="secondary" className="ds-card-label">
              {segment.goodStandingLabel}
            </Text>
            <div className="sq-segment-card__metric">
              {segment.goodStandingValue}
            </div>
          </Col>
        </Row>
      </Flex>
    </Card>
  );
};
